import { MantineTheme } from "@mantine/core";
import { CircleFilledIcon } from "@mcurros2/microm";
import { IconCheck } from "@tabler/icons-react";

export function DispositivosOverrides(theme: MantineTheme) {

    const booleanRender = (value: unknown) => (value === 'true') ? <CircleFilledIcon width="1.3rem" icon={<IconCheck size="0.9rem" />}></CircleFilledIcon> : <></>;

    return {
        //Asegurado
        6: { render: booleanRender },
    }
}